import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTeamIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 146,
	height: 146,
	viewBox: "0 0 146 146",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M73.08 144C112.314 144 144.12 112.194 144.12 72.96C144.12 33.7257 112.314 1.91998 73.08 1.91998C33.8457 1.91998 2.04004 33.7257 2.04004 72.96C2.04004 112.194 33.8457 144 73.08 144Z",
			stroke: "white",
			strokeWidth: 2.71,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49.49 54.07C56.2279 54.07 61.69 48.6437 61.69 41.95C61.69 35.2563 56.2279 29.83 49.49 29.83C42.7521 29.83 37.29 35.2563 37.29 41.95C37.29 48.6437 42.7521 54.07 49.49 54.07Z",
			stroke: "white",
			strokeWidth: 5.38,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39.5 58.24H59.49C63.93 58.24 67.53 61.84 67.53 66.28V69.13C67.53 70.85 66.13 72.25 64.41 72.25H34.58C32.86 72.25 31.46 70.85 31.46 69.13V66.28C31.46 61.84 35.06 58.24 39.5 58.24Z",
			stroke: "white",
			strokeWidth: 5.38,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M96.23 96.76C102.968 96.76 108.43 91.3337 108.43 84.64C108.43 77.9463 102.968 72.52 96.23 72.52C89.4922 72.52 84.03 77.9463 84.03 84.64C84.03 91.3337 89.4922 96.76 96.23 96.76Z",
			stroke: "white",
			strokeWidth: 5.38,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.2299 100.94H106.22C110.66 100.94 114.26 104.54 114.26 108.98V111.83C114.26 113.55 112.86 114.95 111.14 114.95H81.3099C79.5899 114.95 78.1899 113.55 78.1899 111.83V108.98C78.1899 104.54 81.7899 100.94 86.2299 100.94Z",
			stroke: "white",
			strokeWidth: 5.38,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M81.0601 33.06C98.2501 33.06 112.19 47 112.19 64.19",
			stroke: "white",
			strokeWidth: 5.38,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.66 111.71C47.47 111.71 33.53 97.77 33.53 80.58",
			stroke: "white",
			strokeWidth: 5.38,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgTeamIcon;
